import actions from "@/store/payment/actions";
import state from "@/store/payment/states";
import mutations from "@/store/payment/mutations";

const PaymentModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default PaymentModule;